import Constants from 'expo-constants'
import * as Application from 'expo-application'
import { Platform } from 'react-native'
import { isIsolatedPreviewRuntime } from './runtime-build-identity'

/**
 * Build identity is anchored to the installed native package, not a mutable
 * Metro manifest. This keeps the isolated Preview package usable in local
 * device QA while preventing a dev server from ever turning production into a
 * fixture client.
 */
export const isIsolatedPreviewBuild = isIsolatedPreviewRuntime({
  applicationId: Application.applicationId,
  platform: Platform.OS,
  manifestPreviewFlag: Constants.expoConfig?.extra?.isIsolatedPreviewBuild === true,
})

// Metro provides `__DEV__`; plain Node deliberately does not. Keeping the
// diagnostic guarded makes pure transport/map tests exercise the shipped
// runtime identity module instead of needing to fork it for a test runner.
if (typeof __DEV__ !== 'undefined' && __DEV__) {
  console.log('[Tago] Runtime build identity:', {
    applicationId: Application.applicationId,
    platform: Platform.OS,
    manifestPreviewFlag: Constants.expoConfig?.extra?.isIsolatedPreviewBuild === true,
    isIsolatedPreviewBuild,
  })
}
